import { SEARCH_MODAL_HISTORY_KEY } from "../constants";

export function getSearchHistory(): string[] {
  if (typeof window === "undefined") return [];
  try {
    return JSON.parse(localStorage.getItem(SEARCH_MODAL_HISTORY_KEY) ?? "[]");
  } catch {
    return [];
  }
}

export function removeSearchHistory(query: string): void {
  if (typeof query !== "string") return;
  try {
    const trimmed = query.trim();
    const prev = getSearchHistory();
    const data = prev
      .filter((s) => s.toLowerCase() !== trimmed.toLowerCase())
      .reverse();

    localStorage.setItem(
      SEARCH_MODAL_HISTORY_KEY,
      JSON.stringify(data.reverse().slice(0, 5)),
    );
  } catch {
    // As non critical operation, if it fails, we just ignore it
    console.warn("[Search] Failed to save to localStorage");
    return;
  }
}

export function saveSearchHistory(query: string): void {
  // safety first
  if (typeof query !== "string") return;
  try {
    const trimmed = query.trim();

    // If too big let's drop it, we are not aiming to create a library.
    if (trimmed.length > 50) return;

    const prev = getSearchHistory();
    const data = prev
      .filter((s) => s.toLowerCase() !== trimmed.toLowerCase())
      .reverse();
    data.push(trimmed);
    localStorage.setItem(
      SEARCH_MODAL_HISTORY_KEY,
      JSON.stringify(data.reverse().slice(0, 5)),
    );
  } catch {
    // As non critical operation, if it fails, we just ignore it
    console.warn("[Search] Failed to save to localStorage");
    return;
  }
}
